module.exports = __webpack_public_path__ + "static/bbis-careers-2-fafc83d2896ca9fe31ac6024118d9c0f.jpeg";